import React from 'react';
import { Check, ArrowRight, ShieldCheck } from 'lucide-react';
interface PricingProps {
  checkoutUrl: string;
}
export function Pricing({
  checkoutUrl
}: PricingProps) {
  return <div id="pricing-section" className="bg-white rounded-3xl shadow-2xl border-4 border-yellow-400 overflow-hidden max-w-3xl mx-auto transform hover:scale-[1.01] transition-transform duration-300" data-id="element-159">
      {/* Header */}
      <div className="bg-red-600 p-6 text-center text-white" data-id="element-160">
        <h3 className="text-3xl font-bold uppercase tracking-wide" data-id="element-161">
          Oferta Especial Hoy
        </h3>
        <p className="text-red-100 mt-2 font-medium" data-id="element-162">
          Acceso Inmediato + Bonos de Regalo
        </p>
      </div>

      <div className="p-8 md:p-12" data-id="element-163">
        {/* Stack Summary */}
        <div className="space-y-4 mb-8" data-id="element-164">
          <div className="flex items-start gap-3" data-id="element-165">
            <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-166" />
            <span className="text-lg text-gray-700" data-id="element-167">
              <strong data-id="element-168">5 Tomos Completos</strong> de Crianza Sin Celular
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-169">
            <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-170" />
            <span className="text-lg text-gray-700" data-id="element-171">
              <strong data-id="element-172">Bono #1:</strong> Guía de hábitos sanos{' '}
              <span className="text-red-500 font-bold" data-id="element-173">(GRATIS)</span>
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-174">
            <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-175" />
            <span className="text-lg text-gray-700" data-id="element-176">
              <strong data-id="element-177">Bono #2:</strong> Concentración sin celular{' '}
              <span className="text-red-500 font-bold" data-id="element-178">(GRATIS)</span>
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-179">
            <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-180" />
            <span className="text-lg text-gray-700" data-id="element-181">
              <strong data-id="element-182">Bono #3:</strong> Actividades familiares{' '}
              <span className="text-red-500 font-bold" data-id="element-183">(GRATIS)</span>
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-184">
            <Check className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-185" />
            <span className="text-lg text-gray-700" data-id="element-186">
              Acceso de por vida y actualizaciones
            </span>
          </div>
        </div>

        {/* Price Anchor */}
        <div className="text-center mb-8 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-187">
          <p className="text-gray-500 text-lg mb-1" data-id="element-188">
            Precio Regular: <span className="line-through" data-id="element-189">ARS $49.990</span>
          </p>
          <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-190">
            <span className="text-2xl font-bold text-gray-800" data-id="element-191">HOY SOLO:</span>
            <span className="text-5xl md:text-6xl font-black text-red-600 tracking-tight" data-id="element-192">
              ARS $19.990
            </span>
          </div>
          <p className="text-sm text-green-600 font-bold mt-2 uppercase tracking-wide" data-id="element-193">
            ✔ 60% de Descuento Aplicado
          </p>
        </div>

        {/* Main CTA */}
        <a href={checkoutUrl} className="group relative w-full flex items-center justify-center bg-yellow-400 hover:bg-yellow-300 text-red-900 text-2xl md:text-3xl font-black py-6 px-8 rounded-xl shadow-[0_6px_0_rgb(180,83,9)] hover:shadow-[0_4px_0_rgb(180,83,9)] active:shadow-none active:translate-y-[6px] transition-all mb-6 text-center leading-tight" data-id="element-194">
          <span data-id="element-195">OBTENER CRIANZA SIN CELULAR AHORA</span>
          <ArrowRight className="ml-3 w-8 h-8 group-hover:translate-x-1 transition-transform" data-id="element-196" />
        </a>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center text-xs text-gray-500 font-medium" data-id="element-197">
          <div className="flex flex-col items-center gap-1" data-id="element-198">
            <ShieldCheck className="w-6 h-6 text-gray-400" data-id="element-199" />
            <span data-id="element-200">Pago Seguro</span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-201">
            <Check className="w-6 h-6 text-gray-400" data-id="element-202" />
            <span data-id="element-203">Acceso Inmediato</span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-204">
            <Check className="w-6 h-6 text-gray-400" data-id="element-205" />
            <span data-id="element-206">Descarga Digital</span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-207">
            <Check className="w-6 h-6 text-gray-400" data-id="element-208" />
            <span data-id="element-209">Garantía 7 Días</span>
          </div>
        </div>
      </div>
    </div>;
}